// ======================================================================
// File Name       : AuthorityRegistUpdateConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import AuthorityDetail from './AuthorityDetail';
import MessageView from '../../components/MessageView';
import { MESSAGE_TYPE, MODAL_SIZE } from '../../constants/index';

const AuthorityRegisterEditConfirm = ({
  showModal,
  bsSize,
  authority,
  onRegisterEditOk,
  onRegisterEditCancel,
}) => {

  return (
    <Modal
      className="modal-container"
      show={showModal}
      onHide={onRegisterEditCancel}
      size={MODAL_SIZE.lg}
    >
      <Modal.Header onHide={onRegisterEditCancel} closeButton>
        <Modal.Title className="text-center">
          以下の内容で登録します
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AuthorityDetail authority={authority} />
      </Modal.Body>
      <Modal.Footer className="text-center">
        <Button variant="default" className="margin-10 btn-96" onClick={onRegisterEditCancel}>
          キャンセル
        </Button>
        <Button variant="primary" className="margin-10 btn-96" onClick={onRegisterEditOk}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AuthorityRegisterEditConfirm;
